/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_ExpiredInputs */

const en_signin_sso_x15_expired = /** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That single sign-on attempt took too long and expired. Start it again.`)
};

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const ar_signin_sso_x15_expired = en_signin_sso_x15_expired;

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const he_signin_sso_x15_expired = en_signin_sso_x15_expired;

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const ur_signin_sso_x15_expired = en_signin_sso_x15_expired;

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const es_signin_sso_x15_expired = en_signin_sso_x15_expired;

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const fr_signin_sso_x15_expired = en_signin_sso_x15_expired;

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const de_signin_sso_x15_expired = en_signin_sso_x15_expired;

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const pt_signin_sso_x15_expired = en_signin_sso_x15_expired;

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const hi_signin_sso_x15_expired = en_signin_sso_x15_expired;

/** @type {(inputs: Signin_Sso_X15_ExpiredInputs) => LocalizedString} */
const bn_signin_sso_x15_expired = en_signin_sso_x15_expired;

/**
* | output |
* | --- |
* | "That single sign-on attempt took too long and expired. Start it again." |
*
* @param {Signin_Sso_X15_ExpiredInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_expired = /** @type {((inputs?: Signin_Sso_X15_ExpiredInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_ExpiredInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_x15_expired(inputs)
	if (locale === "he") return he_signin_sso_x15_expired(inputs)
	if (locale === "ur") return ur_signin_sso_x15_expired(inputs)
	if (locale === "es") return es_signin_sso_x15_expired(inputs)
	if (locale === "fr") return fr_signin_sso_x15_expired(inputs)
	if (locale === "de") return de_signin_sso_x15_expired(inputs)
	if (locale === "pt") return pt_signin_sso_x15_expired(inputs)
	if (locale === "hi") return hi_signin_sso_x15_expired(inputs)
	if (locale === "bn") return bn_signin_sso_x15_expired(inputs)
	return /** @type {LocalizedString} */ ("That single sign-on attempt took too long and expired. Start it again.")
});